export default __webpack_public_path__ + "static/media/Issac_900.77781e84.webp";